import { DatasetEditorContext } from "@/components/DatasetEditor";
import { useAuth } from "@/context/auth-context";
import { ToastType } from "@/enums";
import { downloadDataset } from "@/queries";
import { displayToast } from "@/utils/toast";
import { DownloadIcon } from "@heroicons/react/outline";
import { useCallback, useContext, useState } from "react";
import { useParams } from "react-router-dom";

export const useDownloadDataset = () => {
  const { datasetId } = useParams<{
    datasetId: string;
  }>();
  const auth = useAuth();
  const userToken = auth?.userToken;
  const { rows, isRowsEmpty } = useContext(DatasetEditorContext);
  const [isDownloading, setIsDownloading] = useState(false);
  const handleDownloadClick = useCallback(async () => {
    try {
      setIsDownloading(true);
      await downloadDataset(userToken!, datasetId!);
      displayToast("Dataset downloaded", ToastType.success);
    } catch (error) {
      console.error("Failed to initiate dataset download:", error);
    } finally {
      setIsDownloading(false);
    }
  }, [datasetId, userToken]);

  return {
    id: "download-dataset",
    label: "Download",
    icon: DownloadIcon,
    getDisabled: () => isRowsEmpty,
    onClick: handleDownloadClick,
    shouldShow: !!rows.length,
    isLoading: isDownloading,
  };
};
